import ReportPage from "../../components/ReportPage";
import { downloadDistributionAudit } from "../../API";

const schema = {
  title: "Stock Level Audit Report",
  params: [
    { name: "banner", label: "Banners", type: "multiselect", route: "banners", required: true },
    {
      name: "products",
      label: "Products",
      type: "multiselect",
      route: "products/for-report-selector",
      cascadesFrom: "banner",
      clearOnManufacturerChange: true,
      buildQueryFn: (banners, commonParams, localValues) => {
        const p = new URLSearchParams();
        if (commonParams.manufacturer?.id) p.set("manufacturerId", commonParams.manufacturer.id);
        const bannerList = Array.isArray(banners) ? banners : [banners];
        bannerList.forEach((b) => p.append("bannerIds", b.id));
        const status = localValues?.productStatus?.id ?? commonParams.itemStatus ?? "ACTIVE";
        if (status !== "ALL") p.set("status", status);
        (commonParams.provinces ?? []).forEach((prov) => p.append("provinceIds", prov.id));
        return "?" + p.toString();
      },
      fields: ["description", "formatQut", "format"],
      payloadKey: "productIds",
      required: true,
    },
  ],
  downloadFn: downloadDistributionAudit,
};

export default function DistributionAuditReport() {
  return <ReportPage schema={schema} />;
}
